<div class="case-feature-result" *ngIf="data() as featureData">
  <div class="case-feature-result__header">
    <span class="case-feature-result__case-name" [title]="featureData.caseName">
      {{ featureData.caseName }}
    </span>
    <span class="case-feature-result__divider"></span>
    <span>{{ featureLabelKey(featureData.feature) | translate }}</span>

    <ui-button
      *ngIf="featureData.feature === 'attachments' && canEdit()"
      class="case-feature-result__add-file"
      size="s"
      type="primary"
      [text]="'CASES.FILES.ADD_FILE' | translate"
      (clickAction)="addFile()"
    ></ui-button>

    <ui-button
      *ngIf="featureData.feature === 'clips' && canEdit()"
      class="case-feature-result__add-file"
      size="s"
      type="primary"
      [text]="'CASES.CLIPS.ADD' | translate"
      (clickAction)="browseArchives()"
    ></ui-button>

    <ui-button
      *ngIf="featureData.feature === 'objects' && canEdit()"
      class="case-feature-result__add-file"
      size="s"
      type="primary"
      [text]="'CASES.OBJECTS.ADD' | translate"
      (clickAction)="browseArchives()"
    ></ui-button>
  </div>

  <div class="case-feature-result__body" [ngSwitch]="featureData.feature">
    <app-case-manager-clips-preview
      *ngSwitchCase="'clips'"
      [caseId]="featureData.caseId"
      [canDownload]="canDownload()"
      [canEdit]="canEdit()"
    ></app-case-manager-clips-preview>

    <app-case-manager-objects-preview
      *ngSwitchCase="'objects'"
      [caseId]="featureData.caseId"
    ></app-case-manager-objects-preview>

    <app-case-manager-files-preview
      *ngSwitchCase="'attachments'"
      [caseId]="featureData.caseId"
      [canDownload]="canDownload()"
      [canEdit]="canEdit()"
      (editAttachment)="editAttachment($event)"
    ></app-case-manager-files-preview>

    <app-case-manager-access-events-preview
      *ngSwitchCase="'accessControlEvents'"
      [caseId]="featureData.caseId"
      [currentUserId]="currentUser()?._id ?? ''"
    ></app-case-manager-access-events-preview>
  </div>
</div>
